<template>
  <div><div class="footer">温馨提示：仅供参考，切勿迷信！</div></div>
</template>
<script>
export default {
  data() {
    return {
    }
  }
}
</script>
<style lang="scss" scoped>
.footer{
  width: 100%;
  text-align: center;
  color: #999;
  margin-top: 12px;
  overflow: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/footer.vue